import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as constants from '../constants-types/constants';
import { SearchState } from '../core-data-model/SearchState.model';
import { SearchStateFactory } from '../core-services/SearchStateFactory';
import { UserProfileSettingsService } from '../system-services/UserProfileSettings/UserProfileSettings.service';
import { TranslationService } from '../translations/Translation.service';

@Component({
    selector: 'pi-pager-results-size-picker',
    template: `
        <div class="pi-pagination_resultsToggle">
            {{ TR.key('tablePager.resultsPerPage') }}
            @for (resultsCount of resultsPerPageOptions; track resultsCount) {
                <a
                    [ngClass]="{
                        'lsg-link': pagingData.resultsPerPage !== resultsCount,
                        'lsg-link--disabled':
                            pagingData.resultsPerPage === resultsCount
                    }"
                    (click)="setResultsPerPage(resultsCount)"
                >
                    {{ resultsCount }}
                </a>
            }
        </div>
    `,
    standalone: false
})
export class PiPagerResultsSizePickerComponent {
    resultsPerPageOptions = [
        constants.tableDefaultResultsPerPage,
        constants.serverApiMaxResults
    ];
    resultsPerPage = this.resultsPerPageOptions[0];

    @Input()
    searchState: SearchState;
    @Output()
    onResultsSizeChange: EventEmitter<number> = new EventEmitter();

    constructor(
        public TR: TranslationService,
        private userProfileSettings: UserProfileSettingsService,
        searchStateFactory: SearchStateFactory
    ) {
        this.searchState = searchStateFactory.newSearchState();
    }

    get pagingData() {
        return this.searchState.pageState;
    }

    setResultsPerPage(resultsPerPage: number): void {
        this.pagingData.resultsPerPage = resultsPerPage;
        this.pagingData.currentPageNumber = 1;
        this.userProfileSettings.preferredPageSize = resultsPerPage;
        this.onResultsSizeChange.emit(resultsPerPage);
    }
}
